module.exports = true;



//////////////////
// WEBPACK FOOTER
// C:/Users/lukas.pavlu/Documents/frontend/node_modules/core-js/library/modules/_library.js
// module id = 29
// module chunks = 0